import { put } from "redux-saga/effects";

import ActivityApiCaller from "../../config/api/activityapicaller";

import { ProfileViewerAction } from "../actions";

export default class ProfileViewerMiddleware {
  static *getProfileViewer({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Get(
        `/activity/profile-view/viewed?sort=${payload.sort ?? ""}`
      );
      if (res?.status === 200) {
        yield put(ProfileViewerAction.getProfileViewerSuccess(res.data?.data));
      } else {
        yield put(ProfileViewerAction.getProfileViewerFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(ProfileViewerAction.getProfileViewerFailure());
    }
  }
  static *getAllProfileViewer({ cb }) {
    try {
      const res = yield ActivityApiCaller.Get(
        `/activity/profile-view-all/viewer`
      );

      if (res?.status === 200) {
        yield put(
          ProfileViewerAction.getAllProfileViewerSuccess(res.data?.data)
        );
      } else {
        yield put(ProfileViewerAction.getAllProfileViewerFailure());
      }
      // if (cb) {
      //   cb(res.data?.data);
      // }
    } catch (err) {
      yield put(ProfileViewerAction.getAllProfileViewerFailure());
    }
  }
  static *getProfileViewed({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Get(
        `/activity/profile-view/viewer?sort=${payload.sort ?? ""}`
      );

      if (res?.status === 200) {
        yield put(ProfileViewerAction.getProfileViewedSuccess(res.data?.data));
      } else {
        yield put(ProfileViewerAction.getProfileViewedFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(ProfileViewerAction.getProfileViewedFailure());
    }
  }
  static *setProfileView({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Post(
        `/activity/profile-view`,
        payload
      );

      if (res.status === 200) {
        yield put(ProfileViewerAction.setProfileViewSuccess(res.data.data));
      } else {
        yield put(ProfileViewerAction.setProfileViewFailure());
      }
      if (cb) {
        cb(res.data.data);
      }
    } catch (err) {
      console.log("error in profile viewer", err);
      yield put(ProfileViewerAction.setProfileViewFailure());
    }
  }
}
